const _map = {};

const modules = require.context('./', true, /[A-Z$]\/index\.js$/);

modules.keys().map((key) => {
  const name = key.split('/')[1];
  modules(key).default.key = name;
  const config = modules(key).default ?? {};
  _map[name] = config;
});

export default _map;
